import { Grid } from '@mui/material';

const BannerVideo = () => {
	return (
		<Grid>
			<dotlottie-player
				src="/assets/video/althin_webmotion.json"
				background="transparent"
				speed="1"
				style={{
					width: '100%',
					height: '100%',
				}}
				loop
				autoplay
			></dotlottie-player>
		</Grid>
	);
};

export default BannerVideo;
